import React from 'react';
import { createPortal } from 'react-dom';
import { Input } from '@/shared/components/ui/Input';
import { Icon } from '@/shared/icons'
interface IntegrationCredentialsModalProps {
  isOpen: boolean;
  onClose: () => void;
  instanceKey: string | null;
  instanceToken: string | null;
  channelName: string;
}

export const IntegrationCredentialsModal: React.FC<IntegrationCredentialsModalProps> = ({
  isOpen,
  onClose,
  instanceKey,
  instanceToken,
  channelName,
}) => {
  const [copiedKey, setCopiedKey] = React.useState(false);
  const [copiedToken, setCopiedToken] = React.useState(false);

  if (!isOpen) return null;

  const handleCopy = async (text: string, type: 'key' | 'token') => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === 'key') {
        setCopiedKey(true);
        setTimeout(() => setCopiedKey(false), 2000);
      } else {
        setCopiedToken(true);
        setTimeout(() => setCopiedToken(false), 2000);
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return createPortal((
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      /* detalhe: NÃO fecha ao clicar fora (DS §Overlays dismissal) */
    >
      <div
        className="relative rounded-lg shadow-xl max-w-2xl w-full mx-4"
        style={{
          backgroundColor: '#ffffff',
          '--theme-text': '#1e293b',
          '--theme-muted-text': '#6b7280',
          '--theme-input-background': '#ffffff',
          '--theme-input-text': '#1e293b',
          '--theme-input-border': 'rgba(0, 0, 0, 0.10)',
          '--theme-input-focus': '#8b5cf6',
          '--theme-error-color': '#ef4444',
        } as React.CSSProperties}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-4 border-b"
          style={{ borderColor: '#e5e7eb' }}
        >
          <div className="flex items-center gap-3">
            <div
              className="p-2 rounded-lg"
              style={{
                backgroundColor: 'rgba(139, 92, 246, 0.1)',
                color: '#8b5cf6',
              }}
            >
              <Icon name="lock" className="w-5 h-5" />
            </div>
            <div>
              <h2
                className="text-lg font-semibold"
                style={{ color: '#1e293b' }}
              >
                Credenciais de Integração
              </h2>
              <p className="text-sm" style={{ color: '#64748b' }}>
                {channelName}
              </p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="p-1 rounded transition-colors"
            style={{ color: '#64748b' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
              e.currentTarget.style.color = '#1e293b';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#64748b';
            }}
          >
            <Icon name="x" className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Instance Key */}
          <div>
            <label
              className="flex items-center gap-2 text-sm font-medium mb-2"
              style={{ color: '#1e293b' }}
            >
              <Icon name="key" className="w-4 h-4" />
              Instance Key
            </label>
            <div className="flex items-center gap-2">
              <div className="flex-1">
                <Input
                  type="text"
                  value={instanceKey || 'Não disponível'}
                  readOnly
                  style={{ backgroundColor: '#f9fafb' }}
                />
              </div>
              {instanceKey && (
                <button
                  onClick={() => handleCopy(instanceKey, 'key')}
                  className="p-2 border rounded-lg transition-colors"
                  style={{
                    backgroundColor: copiedKey ? '#10b981' : '#ffffff',
                    borderColor: copiedKey ? '#10b981' : '#d1d5db',
                    color: copiedKey ? '#ffffff' : '#64748b',
                  }}
                  onMouseEnter={(e) => {
                    if (!copiedKey) {
                      e.currentTarget.style.borderColor = '#8b5cf6';
                      e.currentTarget.style.color = '#8b5cf6';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!copiedKey) {
                      e.currentTarget.style.borderColor = '#d1d5db';
                      e.currentTarget.style.color = '#64748b';
                    }
                  }}
                >
                  {copiedKey ? (
                    <Icon name="check" className="w-4 h-4" />
                  ) : (
                    <Icon name="copy" className="w-4 h-4" />
                  )}
                </button>
              )}
            </div>
          </div>

          {/* Instance Token */}
          <div>
            <label
              className="flex items-center gap-2 text-sm font-medium mb-2"
              style={{ color: '#1e293b' }}
            >
              <Icon name="lock" className="w-4 h-4" />
              Instance Token
            </label>
            <div className="flex items-center gap-2">
              <div className="flex-1">
                <Input
                  type="text"
                  value={instanceToken || 'Não disponível'}
                  readOnly
                  style={{ backgroundColor: '#f9fafb' }}
                />
              </div>
              {instanceToken && (
                <button
                  onClick={() => handleCopy(instanceToken, 'token')}
                  className="p-2 border rounded-lg transition-colors"
                  style={{
                    backgroundColor: copiedToken ? '#10b981' : '#ffffff',
                    borderColor: copiedToken ? '#10b981' : '#d1d5db',
                    color: copiedToken ? '#ffffff' : '#64748b',
                  }}
                  onMouseEnter={(e) => {
                    if (!copiedToken) {
                      e.currentTarget.style.borderColor = '#8b5cf6';
                      e.currentTarget.style.color = '#8b5cf6';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!copiedToken) {
                      e.currentTarget.style.borderColor = '#d1d5db';
                      e.currentTarget.style.color = '#64748b';
                    }
                  }}
                >
                  {copiedToken ? (
                    <Icon name="check" className="w-4 h-4" />
                  ) : (
                    <Icon name="copy" className="w-4 h-4" />
                  )}
                </button>
              )}
            </div>
          </div>

          {/* Info Box */}
          <div
            className="p-4 rounded-lg border"
            style={{
              backgroundColor: '#f0fdf4',
              borderColor: '#bbf7d0',
            }}
          >
            <p className="text-sm" style={{ color: '#166534' }}>
              <span className="font-semibold">Atenção:</span> Estas credenciais
              são necessárias para integração com APIs externas. Não compartilhe
              essas informações com terceiros.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div
          className="flex items-center justify-end gap-3 px-6 py-4 border-t"
          style={{
            backgroundColor: '#f1f5f9',
            borderColor: '#e5e7eb',
          }}
        >
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium border rounded-lg transition-colors"
            style={{
              color: '#1e293b',
              backgroundColor: '#ffffff',
              borderColor: '#e5e7eb',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffffff';
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  ), document.body);
};

IntegrationCredentialsModal.displayName = 'IntegrationCredentialsModal';
